import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Moodboard from "../../../shared/components/Moodboard/Moodboard";
import './MoodboardCampaign.scss';

const MoodboardCampaign = ({ offer }) => {
  const { t } = useTranslation();
  if (!offer) return null;

  return (
    <div className='moodboard-container page'>
      <Container>
        <Row>
          <Col>
            <h3 className="mb-5">{t('influencers.pages.campaign.moodboard.title')}</h3>
          </Col>
        </Row>
        <Moodboard moodboardMedia={offer.moodboard_images} className='moodboard' moodboardClassEnd='-influencer' />
      </Container>
    </div>
  );
};

export default MoodboardCampaign;
